import axios from "axios";

const apiUrl =
     "https://7t0xfgk6y1.execute-api.eu-west-2.amazonaws.com/form";

export const submitForm = (data) => axios.post(apiUrl, data);